module.exports = __webpack_public_path__ + "img/gift.795ee4b3.svg";